module.exports = __webpack_public_path__ + "img/module2.c35aa92.png";